define('v3/Common/Components/PupilDropdown/PupilDropdown.Component',[
	'knockout',
	'lodash',
	'v3/Common/Components/PupilDropdown/Services/pupilService',
	'v3/Common/Services/pageStateService',
	'text!v3/Common/Components/PupilDropdown/PupilDropdown.Component.html',
	'v3/Common/Components/Dropdown/Dropdown.Component'
], function (ko, _, pupilService, pageStateService, htmlString) {
	var pageStatePupilId = pageStateService.getNumberObservable('pupilId');
	var pageStatePupilName = pageStateService.getStringObservable('pupilName');

	function validateParams (params) {
		if (!ko.isWriteableObservable(params.selectedPupilId)) {
			throw new Error('Please provide params.selectedPupilId as a writable observable.');
		}
	}

	function PupilDropdownViewModel (params) {
		var self = this;

		validateParams(params);

		self.pupils = ko.observableArray();
		self.selectedPupilId = params.selectedPupilId;
		var selectedPupilIdSubscriber = self.selectedPupilId.subscribe(function (pupilId) {
			if (!pupilId) return;

			pupilService.savePupilId(pupilId);
			pageStatePupilId(pupilId);

			trySelectPupilNameInParamsAndPageState(pupilId);
		});

		self.disabled = params.disabled || false;

		function selectFirstOrNull () {
			var firstActivePupil = _.first(self.pupils());
			var newSelectedPupilId = firstActivePupil ? firstActivePupil.pupilId : null;
			self.selectedPupilId(newSelectedPupilId);
		}

		function trySelectPupilNameInParamsAndPageState (pupilId) {
			var pupil = _.find(self.pupils(), { pupilId: pupilId });
			var pupilName = pupil ? pupil.longName : null;

			pageStatePupilName(pupilName);
			if (ko.isObservable(params.selectedPupilName)) {
				params.selectedPupilName(pupilName);
			}
		}

		function updatePupils () {
			pupilService.getAllInSubjectGroupsInCurrentClass().done(function (pupils) {
				self.pupils(pupils);

				var initialPupilId = self.selectedPupilId() || pageStatePupilId() || pupilService.getPupilId();
				if (initialPupilId && _.some(pupils, { pupilId: initialPupilId })) {
					self.selectedPupilId(initialPupilId);
				} else {
					selectFirstOrNull();
				}

				pageStatePupilId(self.selectedPupilId());
				trySelectPupilNameInParamsAndPageState(self.selectedPupilId());
			});
		};

		updatePupils();

		self.dispose = function () {
			selectedPupilIdSubscriber.dispose();
		};
	}

	return { viewModel: PupilDropdownViewModel, template: htmlString };
});
